
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 40 40"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd","stroke":"#409EFF","stroke-width":"1.5"}},[_c('path',{attrs:{"d":"M22.817 14.209c1.697.406 3.294 1.308 4.63 2.565a4.672 4.672 0 012.56-.762c2.623 0 4.743 2.162 4.743 4.821 0 2.66-2.12 4.822-4.743 4.822-.08 0-.16-.002-.24-.006-.624.974-1.59 1.797-2.814 2.425a1.75 1.75 0 01-1.749 1.676h-8.648a1.75 1.75 0 01-1.741-1.578c-1.89-.916-3.19-2.278-3.64-3.927L6.101 18.7l1.48-3.016 4.872 3.057c1.466-2.21 3.768-3.92 6.3-4.532a2.177 2.177 0 012.032-2.959 2.177 2.177 0 012.032 2.959z"}}),_c('path',{attrs:{"d":"M30.007 18.571a2.19 2.19 0 00-1.506.601c.835 1.257 1.316 2.602 1.316 3.78l-.002.134c.062.006.127.01.192.01 1.225 0 2.218-1.013 2.218-2.263 0-1.249-.993-2.262-2.218-2.262z"}})])])
          )
        }
      }
    